import React from 'react';
import ReactDOM from 'react-dom';

import './index.scss';
import { App } from './main/ui/App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './main/bll/store';
import { HashRouter as Router } from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
